import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-add',
  standalone: true,
  imports: [],
  templateUrl: './icon-bold-lock-circle.html',
  styleUrl: './icon-bold-lock-circle.scss'
})
export class IconBoldLockCircle {
  @Input() color: string = 'black';
  @Input() size: string = '24px';
}
